import updateFileMeta from '@picsart/cloud-storage/api/updateFileMeta';

import { ErrorMessages } from '@/consts/errors';
import { getCloudStorageHeaders, withCloudStorageErrorHandling } from './utils';

type Params = {
  id: string;
  name: string;
};

const changeDriveFileName = async ({ id, name }: Params) => {
  const result = await withCloudStorageErrorHandling({
    operation: () =>
      updateFileMeta({ fileId: id, name, headers: getCloudStorageHeaders() }),
    errorMessage: ErrorMessages.changeFileName,
  });

  return result?.status === 'success';
};

export default changeDriveFileName;
